module.exports = __webpack_public_path__ + "ico/16.png";